export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-2048w.211deea3.png";